import React from 'react';

function ProfilePicture({
  avatar,
  avatar_text,
  avatar_theme,
  sizeClassName = 'w-6 h-6',
  spacingClassName = 'mr-4',
}) {
  return (
    <div
      className={`${sizeClassName} rounded-full overflow-hidden border border-border-white ${spacingClassName} ${
        avatar ? '' : avatar_theme
      }`}
    >
      {avatar ? (
        <img src={avatar} className='w-full h-full object-cover' alt='' />
      ) : (
        <span className={`avatar__text ${avatar_theme} avatar__text-small`}>
          {avatar_text}
        </span>
      )}
    </div>
  );
}

export default ProfilePicture;
